module.exports = __webpack_public_path__ + "img/phone.7d5e5880.svg";